import { DocumentTemplateFilter } from './../../sub-components/sub-gop-details/documentTemplateFilter';
import { TreatmentServiceOrderExtension } from '@secca/shared/models/service-order/treatment-service-order-extension';
import { Component, Input } from '@angular/core';
import { ServiceTypeBase } from '../../models/serviceTypeBase';
import { ServiceTypeComponent } from '../../models/interfaces';
import moment from 'moment';
import { CaseStakeholder } from '@secca/shared/models/caseStakeholder';
import { ServiceOrderType } from '@secca/shared/models/service-order-type';
import { CommitmentTypes, StatusTypes } from '@secca/shared/models/enums';


@Component({
    selector: 'app-treatment',
    templateUrl: './treatment.component.html',
    styleUrls: ['./treatment.component.scss'],
    standalone: false
})
export class TreatmentComponent extends ServiceTypeBase implements ServiceTypeComponent {

  _treatment: TreatmentServiceOrderExtension;

  private readonly commitmentTypesRequiringReferralSelection = new Set<string>([
    CommitmentTypes.GUARANTEE_OF_PAYMENT,
    CommitmentTypes.EHIC_PARTIAL_GOP,
    CommitmentTypes.EHIC_FULL_COVERAGE,
    CommitmentTypes.VOB_VERIFICATION_OF_BENEFITS,
    CommitmentTypes.PAY_AND_CLAIM_CUSTOMER_POLICY_LOOKUP_DONE_ADVICE_ON_INSURANCE_TERMS_GIVEN
  ]);

  @Input() gopPreviewModelChanged: boolean;

  @Input()
  set treatment(treatment: TreatmentServiceOrderExtension) {
    this._treatment = treatment;
  }

  get treatment() {
    return this._treatment;
  }

  @Input() incidentId: string;
  @Input() caseId: string;
  @Input() supplier: CaseStakeholder;
  @Input() stakeholders: CaseStakeholder[];
  @Input() serviceOrderType: ServiceOrderType;
  @Input() status: StatusTypes;

  defaultStartDate = moment.utc().set({ hour: 9, minute: 0, second: 0, millisecond: 0 });
  defaultEndDate = moment.utc().set({ hour: 15, minute: 0, second: 0, millisecond: 0 });
  treatmentTemplatesFilter = new DocumentTemplateFilter('DOCUMENT', ['GOP', 'VOB'], 'TREATMENT');

  isGOPVisible() {
    return this.treatment.commitmentType && this.treatment.commitmentType.gop;
  }

  isReferralQuestionVisible(): boolean {
    const commitmentTypeBusinessKey = this.treatment?.commitmentType?.businessKey;
    return this.status === StatusTypes.COMMITTED && this.commitmentTypesRequiringReferralSelection.has(commitmentTypeBusinessKey);
  }

  onReferralBySosChanged(value: boolean): void {
    this.treatment.patientReferredBySos = value;
  }

  isPatientReferredBySos(value: boolean): boolean {
    return this.treatment?.patientReferredBySos === value;
  }

  isReferralSelectionMissing(): boolean {
    return this.treatment?.patientReferredBySos === null || this.treatment?.patientReferredBySos === undefined;
  }

  isValid(): boolean {
    let result: boolean;
    if (!this.serviceOrderTypeState.showConfirmationTab) {
      result = this.treatment.isValidExpectation();
    }
    if (this.serviceOrderTypeState.showConfirmationTab) {
      result = this.treatment.isValid();
    }
    return result;
  }

  getModel(): any {
    return this.treatment;
  }
}
